import fetch from '@/common/utils/ftFetch'
import { GATEWAYSER } from '@/common/config/index'
const baseName = "/ylwebsqsserviceonline"
const moduleList = {
  session: `${baseName}/report/session`,
  workOrderTypeWKD: `${GATEWAYSER.SQSIM}/workOrderType`, // 问题类型 小前台
  reportPersonalDayWeekMonth: `${GATEWAYSER.SQSIM}/report/reportPersonalDayWeekMonth`
}

export const incomingLineApi = {
  // 列表
  reqList(params) {
    return fetch.post(`${moduleList.session}/page`, params)
  },
  reqExcel: params => fetch.download(`${moduleList.session}/exportAsync`, { ...params }),
}
// IM进线报表--总计
export const IncomingLineTotal = {
  // 列表
  reqList(params) {
    return fetch.post(`${moduleList.reportPersonalDayWeekMonth}/page`, params)
  },
  // 导出
  reqExcel: params => fetch.download(`${moduleList.reportPersonalDayWeekMonth}/exportAsync`, { ...params }),
  reqHead: (params) => fetch.get(`${moduleList.reportPersonalDayWeekMonth}/head`, params)
}
// 一级类型列表获取， 接口缓存无分页，列表页
export const firstTypeUrl = `${moduleList.workOrderTypeWKD}/list/workOrderFirstType`
// er级类型列表获取， 接口缓存无分页
export const secondTypeUrl = `${moduleList.workOrderTypeWKD}/list/workOrderSecondType`
// 一级问题类型
export const getFirstTypeUrl = () => fetch.get(`${firstTypeUrl}?isEnable=1`)
// 二级问题类型
export const getSecondTypeUrl = () => fetch.get(`${secondTypeUrl}?isEnable=1&firstId=`)
